import { IsSanitizedHtml } from "@wog/mol-lib-api-contract/utils";
import { IsString } from "class-validator";
import { HTTP_VERBS } from "../../enums";
import { AcpNhsDO } from "../domainObjects/v3/acpNhs";
import { AcpNhsStatus } from "../enums";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v3/acp/nhs";

export class Body {
	@IsString()
	@IsSanitizedHtml({ sanitizeHtmlOptions: { allowedTags: [] } })
	id!: string;

	@IsString()
	@IsSanitizedHtml({ sanitizeHtmlOptions: { allowedTags: [] } })
	email!: string;

	@IsString()
	@IsSanitizedHtml({ sanitizeHtmlOptions: { allowedTags: [] } })
	phoneNumber!: string;

	status!: AcpNhsStatus;
}
export class Response extends AcpNhsDO {}
